import { ListState } from '../interfaces'

export const prevPage: <C extends string>(state: ListState<C>) => ListState<C> = state => ({
  ...state,
  page: state.page - 1,
})
